<script lang="ts" setup>
export interface UiAvatarProps {
    autoFallback?: boolean;
    src: string;
    alt?: string;
    size?:
        | "sm"
        | "3xs"
        | "2xs"
        | "xs"
        | "md"
        | "lg"
        | "xl"
        | "2xl"
        | "3xl"
        | "none";
    uiAvatarOptions?: Parameters<typeof createUiAvatar>[0];
    tooltip?: boolean;
    class?: any;
    overSize?: string;
}

const props = withDefaults(defineProps<UiAvatarProps>(), {
    uiAvatarOptions: () => ({}),
    autoFallback: false,
    size: "2xs",
    alt: undefined,
    tooltip: false,
    class: "",
});

const innerSrc = computed(() => {
    if (props.autoFallback && !props.src) {
        return createUiAvatar({
            name: props.alt ?? "-",
            ...props.uiAvatarOptions,
        });
    }

    return props.src;
});

const imgBindings = computed(() => {
    if (props.overSize) {
        return {
            alt: props.alt,
            src: innerSrc.value,
            class: [props.overSize, "object-contain", props.class],
        };
    }

    const size = {
        "3xs": "h-4 max-w-[1rem]",
        "2xs": "h-5 max-w-[1.25rem]",
        xs: "h-6 max-w-[1.5rem]",
        sm: "h-8 max-w-[2rem]",
        md: "h-10 max-w-[2.5rem]",
        lg: "h-12 max-w-[3rem]",
        xl: "h-14 max-w-[3.5rem]",
        "2xl": "h-16 max-w-[4rem]",
        "3xl": "h-20 max-w-[5rem]",
        none: "",
    }[props.size];

    return {
        alt: props.alt,
        src: innerSrc.value,
        class: [size, "object-contain", props.class],
    };
});
</script>

<template>
    <UTooltip v-if="tooltip && alt" :text="alt" :popper="{ placement: 'top' }">
        <img v-bind="imgBindings" />
    </UTooltip>
    <img v-else v-bind="imgBindings" />
</template>
